import React, {useState} from "react"

import styled from "styled-components"
import Flex from "../Flex"
import {TextAreaEmojiPicker, TextReplace} from "../Reactions"
import {EMOJI} from "../Reactions/constants"
import CharacterCountDown from "./CharacterCountDown"
import {CharacterCountDownVariants} from "./CharacterCountDown/enums"

interface Props {
  hasError: boolean
  inputRef?: HTMLInputElement
  onChange: (value: string) => void
  textReplaceTypes: string[]
  value: string
  maxLength?: number
  ExtraActions?: () => JSX.Element
}

const RichEditorWrapperStyled = styled(Flex)`
  display: flex;
  align-items: center;
  position: relative;
  gap: ${({theme}) => theme.spacing.one};
  padding: 6px ${({theme}) => theme.spacing.two};
  height: 36px;
  border: 1px solid ${({theme}) => theme.colors.utility.subdued};
  border-top: 0;
`

const RichEditorWrapper: React.FC<Props> = (props) => {
  const [showFullEmojiPicker, setShowFullEmojiPicker] = useState(false)
  const togglePickerModal = () => setShowFullEmojiPicker(!showFullEmojiPicker)

  const {hasError, inputRef, onChange, textReplaceTypes, maxLength, value, ExtraActions} = props

  return (
    <RichEditorWrapperStyled>
      {textReplaceTypes.includes(EMOJI) && (
        <TextAreaEmojiPicker
          cursorPosition={inputRef?.selectionStart}
          hasError={hasError}
          onChange={(updatedValue: string) => {
            onChange(updatedValue)
            return inputRef?.focus()
          }}
          showFullEmojiPicker={showFullEmojiPicker}
          togglePickerModal={togglePickerModal}
          value={value}
        />
      )}
      {textReplaceTypes.map((t) => (
        <TextReplace
          cursorPosition={inputRef?.selectionStart}
          key={t}
          onChange={(updatedValue: string) => {
            onChange(updatedValue)
            return inputRef?.focus()
          }}
          showFullEmojiPicker={showFullEmojiPicker}
          type={t}
          value={value}
        />
      ))}
      {!!ExtraActions && <ExtraActions />}
      <Flex marginLeft="auto">
        {maxLength && <CharacterCountDown value={value} maxLength={maxLength} variant={CharacterCountDownVariants.SHORT} />}
      </Flex>
    </RichEditorWrapperStyled>
  )
}

export default RichEditorWrapper
